module.exports = __webpack_public_path__ + "img/200m.06a6684e.png";